// extracted by mini-css-extract-plugin
module.exports = {"blocksTable":"blocks-table_blocksTable__qD8VF","body":"blocks-table_body__zY2rW","section":"blocks-table_section__vtyr8"};